import { observer } from 'mobx-react-lite'
import { type IColumn, Table, Tooltip } from 'shared/ui'
import { getLabelAsNumberInternationalFormat, numberFormat } from 'shared/lib'
import type { ISkippedReason } from 'entities/Contacts/api/types'
import type { ImportReasonsStore } from 'pages/contacts/pages/history/store/ImportReasonsStore'
import styles from './styles.module.scss'

type IReason = ISkippedReason & { id: number }

interface IHistoryModalContentProps {
  store: ImportReasonsStore
}

export const HistoryModalContent = observer(({ store }: IHistoryModalContentProps) => {
  const { data, total, paginationData, loading, changePagination } = store

  const columns: IColumn<IReason>[] = [
    {
      field: 'row',
      name: '#',
      minWidth: 84,
      renderRowCell: (row) => (
        <span className={styles.rowCell}>{numberFormat({ value: row.row })}</span>
      ),
    },
    {
      field: 'number',
      name: 'Phone',
      minWidth: 144,
      renderRowCell: (row) => getLabelAsNumberInternationalFormat(row.number.toString()),
    },
    {
      field: 'reason',
      name: 'Reason',
      minWidth: 234,
      maxWidth: 234,
      renderRowCell: (row) => (
        <Tooltip label={row.reason} withoutPointer>
          <span>{row.reason}</span>
        </Tooltip>
      ),
    },
  ]

  const rows: IReason[] = data.map((row, index) => ({ ...row, id: index }))

  return (
    <Table
      ariaLabel={'HistoryModalContent'}
      height='400px'
      rows={rows}
      columns={columns}
      rowsCount={total}
      limit={paginationData.limit}
      initPage={paginationData.page}
      onChangePagination={(page: number, pageSize: number) => {
        changePagination(page, pageSize)
      }}
      isLoading={loading}
    />
  )
})
